import MarketRepository from "../../../Main/repository/MarketRepository";
import MarketSettingLocalStorage from "../../../Main/interface/MarketSettingLocalStorage";
import AppSettingController from "../../../Main/controller/AppSettingController";
import {useEffect, useState} from "react";
import Toast from "../../../../utility/toast";
import {useTranslation} from "react-i18next";

export default function PublicKeyNetbee() {
    const {t} = useTranslation();
    const [state, setState] = useState<string>('')
    const setting = MarketRepository.getSettingMarket() as MarketSettingLocalStorage;

    const SaveHandler = () => {
        try {
            AppSettingController.setPublicKeyNetbee(state)
            Toast.success(t("setting.success.netbeePublicKeySuccess"))
        } catch (e) {
            Toast.error(t("setting.error.netbeePublicKeyFailed"))
        }
    }

    const PasteClipboardHandler = async () => {
        try {
            const text = await navigator.clipboard.readText()
            setState(text)
        } catch (e) {
            Toast.error(t("setting.error.clipboardFailed"))
        }
    }

    useEffect(() => {
        setState(setting.publicKeyNetbee)
    },[])

    return (
        <section className="public-key-container">
            <p>{t("setting.netbeePublicKey")}</p>
            <div className={'public-key'}>
                <input defaultValue={setting.publicKeyNetbee} value={state} onChange={e => setState(e.target.value)}
                       disabled/>
                <button type="button" onClick={PasteClipboardHandler}>{t("paste")}</button>
                <button type="button" onClick={SaveHandler}>{t("submit")}</button>
            </div>
        </section>
    );
}
